export const EDUCATION_LEVELS = [
  "HIGH_SCHOOL",
  "ASSOCIATE",
  "BACHELOR",
  "MASTER",
  "DOCTORATE",
  "CERTIFICATE",
  "OTHER",
];

export const SHIFTS = ["SINGLE", "PARTIAL", "OPEN"];

export const toList = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.content)) return value.content;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  return [];
};

export const titleCase = (value) =>
  String(value || "")
    .replace(/[_-]/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getSectorCode = (sector) => {
  if (!sector) return "GENERAL";
  return typeof sector === "string" ? sector : sector.code || "GENERAL";
};

export const getSectorName = (sector) => {
  if (!sector) return "General";
  if (typeof sector === "string") return titleCase(sector);
  return sector.name || titleCase(sector.code || "General");
};

export const profileTitle = (profile = {}) => {
  const sectorCode = getSectorCode(profile.sector || profile.sectorCode);
  if (profile.profileName) return profile.profileName;
  if (sectorCode === "GENERAL") return "General Professional Profile";
  return `${getSectorName(profile.sector || profile.sectorCode)} Professional Profile`;
};

const credentialType = (item) =>
  String(item?.credentialType || item?.type || item?.category || "").trim().toUpperCase();

const isLicenseCredential = (item) => credentialType(item) === "LICENSE";

export const profileCompletion = (profile = {}) => {
  const checks = [
    Boolean(profile.profileName?.trim()),
    Boolean(profile.sector || profile.sectorCode),
    Boolean(profile.profileSummary?.trim()),
    Boolean(profile.educationLevel),
    toList(profile.previousRegionsWorkedIn).length > 0,
    toList(profile.references).length > 0,
    toList(profile.workExperienceHistory).length > 0,
    toList(profile.education).length > 0,
    toList(profile.documents).length > 0,
    toList(profile.photos).length > 0,
    toList(profile.certifications).length > 0 || toList(profile.licenses).length > 0 || toList(profile.certificates).length > 0,
    toList(profile.interestedServices).length > 0,
    toList(profile.interestedLocations).length > 0,
    toList(profile.interestedShifts).length > 0,
  ];
  return Math.round((checks.filter(Boolean).length / checks.length) * 100);
};

export const blankProfile = (workspaceId) => ({
  sector: undefined,
  sectorCode: "",
  profileType: "SPECIALIZED",
  profileName: "",
  isPrivate: false,
  profileSummary: "",
  educationLevel: "CERTIFICATE",
  workspaceId: workspaceId || null,
  previousRegionsWorkedIn: [],
  references: [],
  workExperienceHistory: [],
  education: [],
  documents: [],
  photos: [],
  photoFileIds: [],
  certifications: [],
  licenses: [],
  interestedServices: [],
  interestedLocations: [],
  interestedShifts: [],
});

export const normalizeProfile = (profile = {}, workspaceId) => ({
  ...blankProfile(workspaceId),
  ...profile,
  profileSummary: profile.profileSummary || [profile.description, profile.experience].filter(Boolean).join("\n\n"),
  previousRegionsWorkedIn: toList(profile.previousRegionsWorkedIn),
  references: toList(profile.references),
  workExperienceHistory: toList(profile.workExperienceHistory),
  education: toList(profile.education),
  documents: toList(profile.documents),
  photos: toList(profile.photos),
  photoFileIds: toList(profile.photoFileIds),
  certifications: [
    ...toList(profile.certifications).filter((item) => !isLicenseCredential(item)),
    ...toList(profile.certificates),
  ],
  licenses: [
    ...toList(profile.certifications).filter(isLicenseCredential),
    ...toList(profile.licenses),
  ],
  interestedServices: toList(profile.interestedServices),
  interestedLocations: toList(profile.interestedLocations),
  interestedShifts: toList(profile.interestedShifts),
});

export const sectionForKey = (key) => {
  switch (key) {
    case "previousRegionsWorkedIn":
      return "previous-regions";
    case "workExperienceHistory":
      return "experience";
    case "references":
      return "references";
    case "education":
    case "educationLevel":
      return "education";
    case "documents":
      return "documents";
    case "photos":
      return "photos";
    case "certifications":
      return "certifications";
    case "licenses":
      return "licenses";
    case "interestedServices":
      return "interested-services";
    case "interestedLocations":
      return "interested-locations";
    case "interestedShifts":
      return "interested-shifts";
    default:
      return "metadata";
  }
};
